import { Flex, Row } from "antd";
import { breakPointsSm } from "src/constants/screen";
import styled from "styled-components";

export const CategoryContent = styled.div`
  max-width: calc(100vw - 290px - 32px - 16px);
  min-width: 333px;
  border-radius: 16px;
  background: var(--0, #fff);
  box-shadow: 0px 4px 6px 0px rgba(113, 130, 183, 0.25);
  transition: all 0.5s;
  display: inline-block;
  /* padding-bottom: 24px; */
  /* height: 683px; */
  margin-inline: auto;
  overflow-x: auto;
  overflow-y: unset;
  @media only screen and (max-width: ${breakPointsSm}px) {
    max-width: calc(100vw - 32px - 16px);
  }
`;
export const CategoryWrapper = styled(Flex)`
  background: var(--0, #fff);
  /* height: 683px; */
`;

export const CategoriesTableContainer = styled.div`
  padding: 24px 16px 32px 16px;
  /* height: 683px; */
  width: 333px;
  &.border-left {
    border-left: 1px solid #f3f4f5;
  }
  .titleHolder {
    color: var(--sidebar-icon, #a3aed0);
    font-family: DM Sans;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
  }
  .shipHolder {
    color: var(--1, #000);
    font-family: DM Sans;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
  }
  .border {
    border-bottom: 1px solid #dadeec;
  }
  .titleHolder {
    color: var(--text-3, #5d6881);
    font-family: DM Sans;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
  }
  .subTitleHolder {
    color: var(--text-2, #a3aed0);
    font-family: DM Sans;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }
  .itemsCountHolder {
    color: var(--text-6, #878787);
    font-family: DM Sans;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }
`;
export const CategoriesChildContainer = styled(Row)`
  overflow-y: hidden;
  overflow-x: hidden;
  max-height: 627px;
  width: 306px;
  &:hover {
    overflow-y: auto;
  }

  .border {
    border-bottom: 1px solid #dadeec;
  }
`;
export const CategoriesChildItemsContainer = styled.div`
  &.selected {
    border: 1px solid var(--color-Light-Mode-Border-1, #a3aed0);
    background: var(--color-Primary-Primary-50, #f4f8ff);
  }
  display: flex;
  width: 300px;
  padding: 12px;
  align-items: center;
  gap: 12px;
  border-radius: 4px;
  justify-content: space-between;
  margin-top: 16px;
  user-select: none;
  cursor: pointer;
  .codeHolder {
    color: var(--text, #fff);
    font-family: DM Sans;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    width: 56px;
    height: 38px;
    border-radius: 6px;
    background: var(--3, #f2f7ff);
    padding: 11px 12px;
    justify-content: center;
    align-items: center;
  }
  .titleHolder {
    color: var(--text-5, #3e4556);
    font-family: DM Sans;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
  }
  .subTitleHolder {
    color: var(--text-6, #878787);
    font-family: DM Sans;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }
`;
